<template>
    <user-view v-if="isStudentView" />
    <admin-view v-else />
</template>

<script>
import UserView from "./UserView.vue";
import AdminView from "./AdminView.vue";

export default {
    name: "volunteering-and-rewards-hub-index",
    components: {
        UserView,
        AdminView,
    },
    created() {
        if (!this.hasPermission('volunteering-and-rewards-hub-module')) {
            this.$router.replace('/no-permission');
        }
    },
    computed: {
        role() {
            return this.$store.getters.role;
        },
        isStudentView() {
            return this.role === 'user';
        },
    },
    methods: {
        hasPermission(crudName) {
            const permissions = this.$store.getters.permissions || '';
            const permissionsArray = permissions.split(",");
            return permissionsArray.includes(crudName);
        },
    },
};
</script>
